import { SvgIcon } from '@progress/kendo-react-common';
import { SVGIcon } from '@progress/kendo-svg-icons';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { ChevronDownOutline, ChevronUpOutline } from '../../../../icons/icons';

export function FlightDetailsSection(props: {
    id?: string;
    icon?: SVGIcon;
    title: string;
    children?: ReactNode;
    buttons?: ReactNode;
    contentClassName?: string;
}) {
    const [expanded, setExpanded] = React.useState(true);

    return (
        <div id={props.id}>
            <div className="d-flex flight-summary-section-header gap-1 border-top">
                <div
                    className="d-flex gap-2 align-items-center ps-2 py-2 flex-grow-1 flex-shrink-0 cursor-pointer"
                    onClick={() => setExpanded(!expanded)}>
                    {props.icon && <SvgIcon icon={props.icon} />}
                    <div>{props.title}</div>
                    <SvgIcon icon={expanded ? ChevronUpOutline : ChevronDownOutline}></SvgIcon>
                </div>
                <div className="flight-summary-button-group d-flex">{props.buttons}</div>
            </div>

            {expanded && <div className={clsx('border-top', props.contentClassName ?? 'px-3 py-2')}>{props.children}</div>}
        </div>
    );
}
